import { render, staticRenderFns } from "./Vol06.vue?vue&type=template&id=267c8f81&scoped=true&"
import script from "./Vol06.vue?vue&type=script&lang=js&"
export * from "./Vol06.vue?vue&type=script&lang=js&"
import style0 from "./Vol06.vue?vue&type=style&index=0&id=267c8f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c8f81",
  null
  
)

export default component.exports